import { render, staticRenderFns } from "./RecipeItemIngredient.vue?vue&type=template&id=5ad81b46&"
import script from "./RecipeItemIngredient.vue?vue&type=script&lang=js&"
export * from "./RecipeItemIngredient.vue?vue&type=script&lang=js&"
import style0 from "./RecipeItemIngredient.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports